import React from 'react';
import PropTypes from 'prop-types';
import graphql from "babel-plugin-relay/macro";
import {DateCell} from "../../../components/common/advance-table/CustomCells";
import {useFragment} from "react-relay";
import {useUser} from "../../../hooks/useUser";
import {Card} from "react-bootstrap";
import CardTableHeader from "../../../components/common/headers/CardTableHeader";
import AdvanceTable from "../../../components/common/advance-table/AdvanceTable";
import AdvanceTablePagination from "../../../components/common/advance-table/AdvanceTablePagination";
import AdvanceTableWrapper from "../../../components/common/advance-table/AdvanceTableWrapper";
import NewFacilityLocationCmsSpecialtyModal from "./NewFacilityLocationCmsSpecialtyModal";
import EditFacilityLocationCmsSpecialtyModal from "./EditFacilityLocationCmsSpecialtyModal";
import DeleteModal from "../../../components/common/modals/DeleteModal";
import {useTableModals} from "../../../hooks/useTableModals";

const cols = [
    {accessor: 'cmsSpecialty.applicableVersion.name', Header: 'CMS Specialty'},
    {accessor: 'numberOfBeds', Header: 'Number of Beds'},
    {accessor: 'effectiveFrom', Header: "Effective From", Cell: DateCell},
    {accessor:'effectiveTo', Header:'Effective To', Cell: DateCell}
]
const FacilityLocationCmsSpecialties = ({facilityLocationId, cmsSpecialties, allCmsSpecialties}) => {
    const deleteMutation = graphql`
    mutation FacilityLocationCmsSpecialtiesDeleteMutation($id: ID!) {
        deleteNode(input: {id: $id}) {
            deletedNodeId @deleteRecord
            owner {
                ... on FacilityLocation {
                    id
                    cmsSpecialties {
                        id
                    }}}}}`
    const data = useFragment(graphql`
        fragment FacilityLocationCmsSpecialties_CmsSpecialties on FacilityLocationCmsSpecialty @relay(plural:true) {
            id
            cmsSpecialty {
                id
                code
                applicableVersion {
                  name
                }
            }
            numberOfBeds
            effectiveFrom
            effectiveTo
        }
    `,cmsSpecialties)
    const {hasPermission} = useUser();
    const {selected, columns, newModal, editModal, deleteModal} = useTableModals(cols, "FacilityLocation.Update", "FacilityLocation.Update");
    return (
        <>
            <AdvanceTableWrapper columns={columns}
                                 data={data}
                                 sortable
                                 pagination
                                 perPage={10}
            >
                <Card className={"mb-3"}>
                    <Card.Header>
                        <CardTableHeader onNewClick={newModal.onClick}
                                         title={"CMS Specialties"}
                                         table
                                         showNew={hasPermission("FacilityLocation.Update")} />
                    </Card.Header>
                    <Card.Body className={"p-0"}>
                        <AdvanceTable table
                                      headerClassName={"bg-200 text-900 text-nowrap align-middle"}
                                      rowClassName={"align-middle white-space-nowrap"}
                                      tableProps={{size: "sm", striped: true, className: "fs--1 mb-0 overflow-hidden"}}
                        />
                    </Card.Body>
                    <Card.Footer>
                        <AdvanceTablePagination table />
                    </Card.Footer>
                </Card>
            </AdvanceTableWrapper>
            <NewFacilityLocationCmsSpecialtyModal showModal={newModal.showModal}
                                              onClose={newModal.onClose}
                                              cmsSpecialties={allCmsSpecialties}
                                              facilityLocationId={facilityLocationId}
            />
            {selected && <EditFacilityLocationCmsSpecialtyModal showModal={editModal.showModal}
                                                            onClose={editModal.onClose}
                                                            selectedCmsSpecialty={selected}
                                                            cmsSpecialties={allCmsSpecialties}
            />}
            {selected && <DeleteModal mutation={deleteMutation}
                                      onClose={deleteModal.onClose}
                                      thingToDelete={"CMS Specialty"}
                                      showModal={deleteModal.showModal}
                                      id={selected.id}
            >
                <p>This cannot be undone.</p>
            </DeleteModal>}
        </>
    )
}
FacilityLocationCmsSpecialties.propTypes = {
    facilityLocationId: PropTypes.string.isRequired,
    allCmsSpecialties: PropTypes.array.isRequired,
    cmsSpecialties: PropTypes.array.isRequired
}
export default FacilityLocationCmsSpecialties